import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '..';
import { IOpsSchedule, IContact } from '../../models';

export const ActionTypes = {
}

export interface IOpsScheduleListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            schedule: IOpsSchedule[],
            staffList: IContact[]
        }
    }
}

export interface IStaffListResponse {
    data: {
        success: boolean,
        message: string,
        results: IContact[]
    }
}

export interface IOpsScheduleRefreshResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            schedule: IOpsSchedule[],
            staffList: IContact[]
        }
    }
}

export interface IOpsScheduleSaveResponse {
    data: {
        success: boolean,
        message: string,
        results: IOpsSchedule[]
    }
}

export const ActionCreators = {
    getOpsSchedule: () => async (dispatch: Dispatch<IApplicationState>): Promise<IOpsScheduleListResponse> => {
        var options = {
            url: __API__ + '/staff/ops-schedule'
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    refreshOpsSchedule: () => async (dispatch: Dispatch<IApplicationState>): Promise<IOpsScheduleRefreshResponse> => {
        var options = {
            url: __API__ + '/public/command-center/ops-schedule/refresh'
        };

        try {
            return await dispatch(AuthActionCreators.apiGetPublic(options));
        } catch (error) {
            throw error;
        }
    },
    saveOpsSchedule: (requestList: IOpsSchedule[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IOpsScheduleSaveResponse> => {
        var options = {
            url: __API__ + '/staff/ops-schedule',
            data: requestList
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    getStaffList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IStaffListResponse> => {
        var options = {
            url: __API__ + '/staff'
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
}

export interface IOpsScheduleState {
}

var initialState: IOpsScheduleState = {
};

const createReducer = (initialState: IOpsScheduleState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
